import { render, staticRenderFns } from "./AttributionLogTable.vue?vue&type=template&id=daa59b7c&scoped=true"
import script from "./AttributionLogTable.vue?vue&type=script&lang=js"
export * from "./AttributionLogTable.vue?vue&type=script&lang=js"
import style0 from "./AttributionLogTable.vue?vue&type=style&index=0&id=daa59b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa59b7c",
  null
  
)

export default component.exports